import { Link } from "react-router-dom";
import { Calculator, Sparkles, ArrowRight, ShieldCheck } from "lucide-react";

export default function CalculatorPromo() {
  return (
    <section
      data-testid="calculator-promo"
      className="section-pad bg-brand-obsidian text-brand-bone relative overflow-hidden"
    >
      <div aria-hidden className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-amber-400/10 blur-3xl" />
      <div aria-hidden className="absolute -bottom-24 -left-24 w-[320px] h-[320px] rounded-full bg-amber-500/5 blur-3xl" />

      <div className="container-page relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-sm bg-white/5 border border-white/10 text-xs font-semibold tracking-[0.18em] uppercase text-amber-400">
            <Sparkles className="w-3.5 h-3.5" /> New · Free Tool
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.04] mt-6">
            Build your ADU with ME Builders.
          </h2>
          <p className="mt-5 text-brand-bone/80 max-w-xl leading-relaxed">
            Thinking about a garage conversion, detached ADU, or backyard unit? Use our free ADU Cost
            Calculator to get a realistic budget range in seconds — every property is different, but this
            tool gives you a helpful starting point before scheduling a full consultation.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/adu-calculator"
              data-testid="home-calculator-cta"
              className="inline-flex items-center gap-2 bg-amber-400 text-brand-obsidian hover:bg-amber-300 rounded-sm px-6 py-3.5 font-semibold transition-all duration-200 hover:-translate-y-0.5 text-sm"
            >
              <Calculator className="w-4 h-4" /> Calculate My ADU Cost
              <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/services/adu" className="inline-flex items-center gap-2 bg-white/5 text-brand-bone hover:bg-white/10 rounded-sm px-6 py-3.5 font-semibold transition text-sm">
              Learn about ADU service
            </Link>
          </div>

          <div className="mt-8 flex items-center gap-2 text-xs text-brand-bone/60">
            <ShieldCheck className="w-4 h-4 text-amber-400" /> Preliminary range only — not a guaranteed quote.
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-md border border-white/10 bg-white/5 p-8 backdrop-blur-sm">
            <p className="text-xs uppercase tracking-[0.2em] font-semibold text-amber-400">Typical ADU budget</p>
            <p className="font-heading text-5xl md:text-6xl font-extrabold tracking-tighter mt-3">
              $150K
            </p>
            <p className="font-heading text-3xl font-bold text-brand-bone/70 mt-1">
              – $450K<span className="text-amber-400">+</span>
            </p>
            <div className="border-t border-white/10 mt-6 pt-6 grid grid-cols-2 gap-y-3 gap-x-4 text-sm">
              {[
                ["Garage Conversion", "$225/sqft"],
                ["Junior ADU", "$250/sqft"],
                ["Attached ADU", "$290/sqft"],
                ["Detached ADU", "$340/sqft"],
              ].map(([k, v]) => (
                <div key={k} className="flex flex-col">
                  <span className="text-brand-bone/60 text-xs uppercase tracking-wide">{k}</span>
                  <span className="font-heading font-bold text-brand-bone">{v}</span>
                </div>
              ))}
            </div>
            <p className="text-[11px] text-brand-bone/50 mt-5">
              Base rates only. Final cost depends on finishes, utilities, foundation, and site conditions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
